import { AttachmentType, ContentFilter } from "@dashboard-v3/api";

export const attachmentSizeOpts = [
  { key: crypto.randomUUID(), value: "BYTE", text: "Bytes" },
  { key: crypto.randomUUID(), value: "KILOBYTE", text: "Kilobytes" },
  { key: crypto.randomUUID(), value: "MEGABYTE", text: "Megabytes" },
];

export const getContentFilterDefaults = (): ContentFilter => ({
  attachmentSize: null,
  includeAttachmentExtensions: [],
  excludeAttachmentExtensions: [],
  includeAttachmentNames: [],
  excludeAttachmentNames: [],
  includeAttachmentTypes: [] as AttachmentType[],
  excludeAttachmentTypes: [] as AttachmentType[],
  excludeInlineImages: true,
  includeZipWithPassword: false,
  includeRfc822: true,
  excludeMultipartReport: true,
  includeTnef: false,
});
